import { formatYen } from "@ippon/shared-utils";

export const formatMonthlyAndUnitPrice = (
  monthlyAmount: number,
  unitPrice: number,
): string => {
  const formattedUnitPrice =
    unitPrice > 0 ? `${formatYen(unitPrice)}/坪` : "-";
  return `${formatYen(monthlyAmount)}（${formattedUnitPrice}）`;
};

export const formatTsuboArea = (areaTsubo: number): string =>
  areaTsubo > 0 ? `${areaTsubo.toLocaleString("ja-JP")}坪` : "-";

export const formatTsuboUnitPrice = (unitPrice: number): string =>
  `${formatYen(unitPrice)}/坪`;

export const formatContractPeriod = (
  startDate: string,
  endDate: string,
): string => {
  if (!startDate && !endDate) return "-";
  return endDate
    ? `${startDate || "-"} ～ ${endDate}`
    : `${startDate || "-"} ～`;
};
